import { render } from "./ProgramIndex.vue?vue&type=template&id=ca772fda"
import script from "./ProgramIndex.vue?vue&type=script&lang=js"
export * from "./ProgramIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__